module.exports = __webpack_public_path__ + "statics/img/vip_banner.51753ccb.png";